import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { MetadatiRepertorioDTO } from "../dto/metadati-repertorioDTO";
import { MetadatiRepertorioVO } from "../vo/metadati-repertorioVO";
import { DatiReportorioManualiVO } from "../vo/dati-repertorio-manualiVO";
import { DatiReportorioManualiDTO } from "../dto/dati-repertorio-manualiDTO";
import { MapperSettore } from "./mapper-settore";

@Injectable({
  providedIn: "root",
})
export class MapperDatiRepertorioManuali
  implements
    MapperInterface<DatiReportorioManualiDTO, DatiReportorioManualiVO> {
  constructor(private mapperSettore: MapperSettore) {}

  convertVoToDto(vo: DatiReportorioManualiVO): DatiReportorioManualiDTO {
    if (vo != null) {
      const dto = new DatiReportorioManualiDTO();
      dto.id = vo.id;
      dto.anno = vo.anno;
      dto.segnatura = vo.segnatura;
      dto.data = vo.data;
      dto.mese = vo.mese;
      dto.numero = vo.numero;
      dto.privato = vo.privato;
      dto.struttureAggiuntive = this.mapperSettore.convertListVoToDto(
        vo.struttureAggiuntive
      );
      return dto;
    } else {
      return null;
    }
  }
  convertDtoToVo(dto: DatiReportorioManualiDTO): DatiReportorioManualiVO {
    if (dto != null) {
      const vo = new DatiReportorioManualiVO();
      vo.id = dto.id;
      vo.segnatura = dto.segnatura;
      vo.anno = dto.anno;
      vo.data = dto.data;
      vo.mese = dto.mese;
      vo.numero = dto.numero;
      vo.privato = dto.privato;
      vo.struttureAggiuntive = this.mapperSettore.convertListDtoToVo(
        dto.struttureAggiuntive
      );

      // TODO terminare
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: DatiReportorioManualiVO[]): DatiReportorioManualiDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: DatiReportorioManualiDTO[]): DatiReportorioManualiVO[] {
    throw new Error("Method not implemented.");
  }
}
